
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_60911_8060)"}},[_c('circle',{attrs:{"cx":"15.248","cy":"9.258","r":"7.771","transform":"rotate(45 15.248 9.258)","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 14.5h7M10 11h3m-1.458-6.333a6.877 6.877 0 016.737 5.503l.138-.003a4.583 4.583 0 01.235 9.16l-.235.006H6.5l-.283-.007a5.5 5.5 0 01-.813-10.884 6.874 6.874 0 016.138-3.775z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_60911_8060"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    